import { mapServerToSpecificationsBase } from "./map-server-to-specifications-base.js";
import { getUnlocalizedSpecificationItem } from "../../../../utils/mappers/server-to-client/utils/get-unlocalized-specification-item.js";
import { getSpecificationItems } from "../../../../utils/mappers/server-to-client/utils/get-specification-items.js";
const mapServerToAccessoriesSpecifications = (serverVariant, brand) => {
  const {
    targetGender,
    targetGenderAllLocales,
    color,
    colorAllLocales,
    accessoryType,
    material,
    materialAllLocales
  } = serverVariant.variantTypeDetails;
  const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
  const materialUnlocalized = getUnlocalizedSpecificationItem(materialAllLocales);
  const accessoryColorUnlocalized = getUnlocalizedSpecificationItem(colorAllLocales);
  const accessoryTypeUnlocalized = getUnlocalizedSpecificationItem(
    accessoryType?.displayNameAllLocales
  );
  const serverSpecifications = {
    targetGender,
    genderUnlocalized,
    accessoryColor: color,
    accessoryColorUnlocalized,
    accessoryType: accessoryType?.displayName,
    accessoryTypeUnlocalized,
    material,
    materialUnlocalized
  };
  return [
    ...mapServerToSpecificationsBase(serverVariant, brand),
    ...getSpecificationItems(serverSpecifications)
  ];
};
export {
  mapServerToAccessoriesSpecifications
};
//# sourceMappingURL=map-server-to-accessories-specifications.js.map
